import React from 'react';
import logoUrl from '../../../../public/logo.png?url';

/**
 * LineSide company mark (gear + circuit) for LineSide agents.
 * Uses the same logo asset as the app favicon and landing site.
 */
const LineSideIcon = ({ size = 24, className = '' }) => (
  <img
    src={logoUrl}
    alt=""
    aria-hidden="true"
    width={size}
    height={size}
    className={`object-contain ${className}`.trim()}
    draggable={false}
  />
);

export default LineSideIcon;
